export const useToolbar = () => useState<boolean>('useToolbar', () => false);
